import React, { useState, useRef } from "react";
import Slider from "react-slick";
import { useMediaQuery } from "react-responsive";
import { wordEllipsis } from "../../utils/strings";

const MediaMentions = ({ content }) => {
  const [hoveredIndex, setHoveredIndex] = useState(0);
  const isMobile = useMediaQuery({ query: "(max-width: 992px)" });

  const settings = {
    className: "mediaMentions center",
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: isMobile ? 1 : 5,
    slidesToScroll: 1,
    beforeChange: (_, next) => setHoveredIndex(next),
    centerMode: true,
    centerPadding: "0px",
    autoplay: true,
    pauseOnHover: false
  };

  const ref = useRef();

  return (
    <div id="mediaMentions" className="full-width">
      <div className="centralContainer">
        <div className="titleContainer">
          <p className="title">“{wordEllipsis(content?.items?.[hoveredIndex]?.title, isMobile ? 140 : 180)}”</p>
        </div>
        <Slider ref={ref} {...settings}>
          {content?.items.map((element, index) => (
            <div
              key={index}
              className="itemContainer"
              onClick={() => {
                const isLast = content?.items?.length - 1;
                if (!index && hoveredIndex === isLast) {
                  ref.current.slickNext();
                } else if (index === isLast && !hoveredIndex) {
                  ref.current.slickPrev();
                } else {
                  ref.current.slickGoTo(index);
                }
              }}>
              <div className="item">
                <img
                  key={index}
                  src={element.image.url}
                  alt="logo"
                  style={index === hoveredIndex ? { filter: "unset" } : {}}
                />
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </div>
  );
};

export default MediaMentions;
